import axios from "axios";

const login = async () => {
  try {
    const response = await axios.post(
      "https://ecommerce-jin.upintelligence.es/admin/auth/login",
      {
        email: process.env.VUE_APP_STRAPI_USERNAME,
        password: process.env.VUE_APP_STRAPI_PASSWORD
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    // Guardar el token de autenticación en local storage o en una variable
    const token = response.data.jwt;
    // ...
  } catch (error) {
    console.error("Error al autenticar en Strapi:", error);
  }
};

export default login;



// WEBPACK FOOTER //
// ./src/services/Strapi.js